<div class="container-fluid p-0 h-100 w-100" style="min-width: 600px">
  <div class="d-flex align-items-center justify-content-between">
    <h4>{{ 'KM ' + minValue }}</h4>
    <h4>{{ 'KM ' + maxValue }}</h4>
  </div>
  <div class="outside-line d-flex align-items-center">
    <div class="line position-relative" id="pathLine" style="height: 32px" #lineParent>
      <div
        (click)="setElementPosition(IndexFill)"
        class="fill"
        [id]="'pathFill-' + IndexFill"
        *ngFor="let filler of rangeValueFillList; index as IndexFill"
        [ngStyle]="{
          'border-radius':
            IndexFill == 0 ? '8px 0 0 8px' : IndexFill == rangeValueFillList?.length - 1 ? '0 8px 8px 0' : '0'
        }"
      ></div>
      <div
        cdkDrag
        [cdkDragFreeDragPosition]="dragPosition"
        class="handle"
        [id]="'pathHandle'"
        cdkDragLockAxis="x"
        cdkDragBoundary=".outside-line"
      >
        <i class="fa-solid fa-angle-left fa-lg"></i>
        <i class="fa-solid fa-angle-right fa-lg"></i>
      </div>
    </div>
  </div>
</div>
